/* eslint-disable */
import React, { useState, useEffect } from 'react'; // eslint-disable-next-line
import Rive from '@rive-app/react-canvas';
import './App.css';
import Header from './components/navbar/Header';
import Footer from './components/navbar/Footer';
import Main from './components/dashboard/Main';
import History from './components/events/History';
import Future from './components/events/Future';
import Details from './components/about/Details';
import EventDetails from './components/events/EventDetails';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { copiriPortalRequest, getLanguagePackUrl } from './components/api/api';
import { config } from './components/config/config'; // eslint-disable-next-line
import loading_image from './assets/img/loader/loader.webp'; // eslint-disable-next-line
const App = () => {
	const [pageLanguageContent, setPageLanguageContent] = useState([]); // eslint-disable-next-line
	const [showLoader,setShowLoader]  = useState(true);
	useEffect(() => {
		getLanguagePack();
		// eslint-disable-next-line
	}, []);

	/* function to get the translated language text */
	function getLanguagePack() {
		let checkData = JSON.parse(localStorage.getItem('idiom'));
		let getLanguageURL = getLanguagePackUrl();
		copiriPortalRequest(getLanguageURL, config.app_version, 'get')
			.then((response) => {
				setShowLoader(false)
				if (response?.data?.WCS?.HME) {
					setPageLanguageContent(response?.data?.WCS);
					localStorage.setItem('idiom', JSON.stringify(response?.data?.WCS));
				}
			})
			.catch((error) => {setShowLoader(false)});
	}
	return (
		<div className='App'>
			<BrowserRouter>
				{
					showLoader?
					<div className="showRiveLoader">
						<Rive src="/rive_loader.riv" style={{ height: "400px"}}/>
					</div>
				:
				<>
					<Header />
					<Routes>
						<Route path='/' exact element={<Main />}></Route>
						<Route path='/history' exact element={<History />}></Route>
						<Route path='/future' exact element={<Future />}></Route>
						<Route path='/details' exact element={<Details />}></Route>
						<Route path='/event-details/:type/:id' exact element={<EventDetails />}></Route>
					</Routes>
					<Footer />
				</>
				}
			</BrowserRouter>
		</div>
	);
};

export default App;
